var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2751 23.9748C38.3323 14.9863 32.7134 6.03203 23.7249 3.97485C14.7363 1.91767 5.78203 7.53663 3.72485 16.5251C1.66767 25.5137 7.28663 34.468 16.2751 36.5251C25.2637 38.5823 34.218 32.9634 36.2751 23.9748Z",
    stroke: "white",
    strokeWidth: 6.5947,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2751 23.9748C38.3323 14.9863 32.7134 6.03203 23.7249 3.97485C14.7363 1.91767 5.78203 7.53663 3.72485 16.5251C1.66767 25.5137 7.28663 34.468 16.2751 36.5251C25.2637 38.5823 34.218 32.9634 36.2751 23.9748Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 29.0045L10.907 26.6462H29.1383L29.9546 29.0045H10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.5351V14.4921L20.0227 11L30 14.4921V15.5351H10Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5941 17.1224L29.1837 16.2154H10.907L11.4966 17.1224H28.5941Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4898 25.9206V17.7573H12.4944V25.9206H14.4898Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8436 25.9206V17.7573H16.8481V25.9206H18.8436Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1974 25.9206V17.7573H21.2019V25.9206H23.1974Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5511 25.9206V17.7573H25.5557V25.9206H27.5511Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.8634fa3006886cafc8c5c6cb3d4bd2a6.svg";
export { ForwardRef as ReactComponent };